import { ReactNode } from "react";

import { formatAttributeValue } from "../../../utils/formatAttributeValue";
import { FeatureAttribute } from "../components/Attributes/FeatureAttributeField";

export const tooltipValueFromAttributes = (
  value: number,
  name?: string,
  attributes?: FeatureAttribute[],
): number | string | ReactNode => {
  const attribute = attributes?.find(attr => attr.name === name);

  return attribute ? formatAttributeValue(attribute.type, value, attribute.stringFormat) : value;
};
